@if (dataSource.page$ | async; as page) {
  <mat-paginator [length]="page.totalElements" [pageSize]="page.size"
    _formFieldAppearance="fill" [pageIndex]="page.number" [hidePageSize]="true"
                 (page)="dataSource.fetch($event.pageIndex)">
  </mat-paginator>
}
